var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cursor-pointer bs-5 fl-x blue-outline"},[_c('div',{staticClass:"bg-3 p-lg-2 p-1 bs-r fl-x-cc"},[_c('i',{staticClass:"text-white",class:_vm.icon}),_vm._t("image")],2),_c('div',{staticClass:"bg-primary p-lg-2 px-lg-4 fs-lg-1 p-1 fl-x-cc"},[_c('p',{staticClass:"m-0"},[_vm._v(_vm._s(_vm.text))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }